export const getHasPageProductDetails = ({ productDescription, targetAudience, uniqueSellingProposition }) =>
    productDescription && targetAudience && uniqueSellingProposition;
